import { CardContainer, SectionHeadingSkeleton } from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <CardContainer>
      <SectionHeadingSkeleton />
      <PhoneNumberLoading />
    </CardContainer>
  );
}
